import React, { Component } from "react";

import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

class ConfirmDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: true };
  }

  onHide = () => this.setState({ visible: false });

  render() {
    let actions = [
      this.props.okButtonText && <Button key="ok" onClick={this.props.onOkClick}>{this.props.okButtonText}</Button>,
      this.props.cancelButtonText && <Button key="cancel" variant="secondary" onClick={this.props.onCancelClick}>{this.props.cancelButtonText}</Button>
    ];

    return (
      <Dialog
        open={this.state.visible}
        onClose={this.onHide}
        id={"confirm-dialog"}
        sx={{ '& .MuiDialog-paper': { width: 500 } }}
      >
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent>
          {this.props.message}
          {this.props.question}
        </DialogContent>
        <DialogActions>
          {actions}
        </DialogActions>
      </Dialog>
    );
  }
}

ConfirmDialog.propTypes = {
  onOkClick: PropTypes.func.isRequired,
  okButtonText: PropTypes.string,
  onCancelClick: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  title: PropTypes.node,
  message: PropTypes.node,
  question: PropTypes.node,
};

ConfirmDialog.defaultProps = {
  okButtonText: "Confirm",
  cancelButtonText: "Cancel",
  title: "Confirm",
  question: null,
  message: null,
};

export default ConfirmDialog;
